import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import { useParams } from 'react-router-dom-v7';
import MFTabs from '../../components/MFTabs';
// Example tab components
const OverviewTab = () => (_jsxs(Box, { p: 6, children: [_jsx(Heading, { size: "md", mb: 4, children: "Overview" }), _jsx(Text, { children: "This is the overview tab content. It shows general information." })] }));
const DetailsTab = () => (_jsxs(Box, { p: 6, children: [_jsx(Heading, { size: "md", mb: 4, children: "Details" }), _jsx(Text, { children: "This is the details tab. It contains detailed information." })] }));
const SettingsTab = () => (_jsxs(Box, { p: 6, children: [_jsx(Heading, { size: "md", mb: 4, children: "Settings" }), _jsx(Text, { children: "This is the settings tab. Configure your preferences here." })] }));
/**
 * Example view demonstrating MFTabs with search params routing
 *
 * Routes setup in MFRouterRR7.tsx:
 * <Route path="/tabs-example-search/:id" element={<SearchParamsExample />} />
 *
 * URLs will look like:
 * - /tabs-example-search/123?tab=overview
 * - /tabs-example-search/123?tab=details
 * - /tabs-example-search/123?tab=settings
 */
export default function SearchParamsExample() {
    const { id } = useParams();
    const tabs = [
        {
            label: 'Overview',
            component: OverviewTab,
            slug: 'overview',
            searchParamValue: 'overview' // Will be: ?tab=overview
        },
        {
            label: 'Details',
            component: DetailsTab,
            slug: 'details',
            searchParamValue: 'details' // Will be: ?tab=details
        },
        {
            label: 'Settings',
            component: SettingsTab,
            slug: 'settings',
            searchParamValue: 'settings' // Will be: ?tab=settings
        }
    ];
    return (_jsxs(VStack, { align: "stretch", spacing: 6, p: 6, children: [_jsxs(Box, { children: [_jsx(Heading, { size: "lg", mb: 2, children: "Tabs Example (Search Params Routing)" }), _jsxs(Text, { color: "gray.600", children: ["ID: ", id] }), _jsx(Text, { fontSize: "sm", color: "gray.500", mt: 2, children: "This example uses search params routing. All tabs share the same route with different query parameters." })] }), _jsx(MFTabs, { tabs: tabs, enableRouting: true, routingMode: "searchParams", searchParamKey: "tab" // Optional, defaults to 'tab'
                , defaultTab: "overview", variant: "nav", onTabChange: (slug, index) => {
                    // Tab change handler
                    // eslint-disable-next-line no-console
                    console.log(`Tab changed: ${slug} (index: ${index})`);
                } })] }));
}
